module.exports = __webpack_public_path__ + "static/media/like_product_1.578d0086.svg";